import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Picture from '../../atoms/picture';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  justify-content: center;
  text-align: center;

  @media screen and (min-width: ${(props) => props.theme.breakpoint.small}) {
    width: 33.3333%;
  }
`;

const ColorStoryCellImage = (props) => (
  <Wrapper>
    {props.data?.color_story_cell_image_desktop
      && (
        <Picture
          {...props.data.color_story_cell_image_desktop}
          alt={props.data.color_story_cell_image_desktop_alt}
        />
    )}
  </Wrapper>
);

ColorStoryCellImage.propTypes = {
  data: PropTypes.object.isRequired
};

ColorStoryCellImage.whyDidYouRender = true;

export default ColorStoryCellImage;
